import { createContext, useContext, ReactNode, useState } from 'react';
import { api } from '../../services/services/api';

interface PainelProcessamentoCOntextProps {
  children: ReactNode;
}

interface PainelProcessamentoContextProps {
  logs: Logs[];
  getLogs: (filtro: ValoresFiltros) => Promise<void>;
}

const PainelProcessamentoContext =
  createContext<PainelProcessamentoContextProps>(
    {} as PainelProcessamentoContextProps,
  );

export interface Logs {
  id: number;
  step: string;
  inicio: string;
  final: string;
  status: string;
  finalizado: boolean;
  percentual: number;
  ultimaAtualizacao: string;
}

interface ValoresFiltros {
  dataInicio: string;
  dataFim: string;
}

export const PainelProcessamentoProvider = ({
  children,
}: PainelProcessamentoCOntextProps) => {
  const [logs, setLogs] = useState<Logs[]>([]);

  async function getLogs(filtro: ValoresFiltros) {
    await api
      .get(`/painel-processamento`, {
        params: {
          dataInicio: filtro.dataInicio,
          dataFim: filtro.dataFim,
        },
      })
      .then(({ data }: any) => {
        setLogs(data.data);
      });
  }

  return (
    <PainelProcessamentoContext.Provider value={{ logs, getLogs }}>
      {children}
    </PainelProcessamentoContext.Provider>
  );
};

export const usePainelProcessamento = () =>
  useContext(PainelProcessamentoContext);
